enum TicketTypeApprovalEmailLayout {
    Execution = 1,
    Analysis = 2
}

export default TicketTypeApprovalEmailLayout;